import React, { Component, forwardRef } from 'react';
import { connect } from "react-redux";
import Header from "../../common_components/Header";
import Drawer from "../../common_components/Drawer";
import { lastSubmitAdd_action } from "../../actions/last_submit_action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withRouter } from "../../utils/withRouter";
import moment from "moment";
import Modal from "react-modal";
import { sendPaymentForm_action } from "../../actions/payment_action/payment_action";
import Loader from "../../utils/Loader";
import {
  clearSessionStorage,
  countryActionId,
  toastError,
  toastSuccess,
  countryIWithCodeActionId,
  timeout,
} from "../../utils/constants";
import Pagination from "../../utils/pagination";
import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { fill_action } from "../../actions/fillCombo_action";
import StepHeader from "./stepHeader";
import Footer from "../../common_components/Footer";
import $ from "jquery";
import { paymentPortalLink, paymentAccessCode, paymentMasterListActionId, surchargeListActionId } from "../../utils/constants";

class LastSubmit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      pgViewChargesModal: false,
      geturl: "",

      openPaymentPop: false,
      toPay: '',
      toPaydummy: '',
      paymentType: '',
      customPayment: '',
      isCustompayment: '',
      minPay: '',
      encPayload: '',
      remark: '',
      isPaymentEnable: false,
      paymentMasterList: [],
      paymentLink: '',
      pgViewChargesFillList: [],
      isSurchargeForceOpen: true,

    };
    this.submitfrm = React.createRef()

    this.onSubmit = this.onSubmit.bind(this);
    this.onPreviousClick = this.onPreviousClick.bind(this);
    this.loadscript = this.loadscript.bind(this);

    this.onPayAndSubmit = this.onPayAndSubmit.bind(this)
    this.onPaymentTypeSelect = this.onPaymentTypeSelect.bind(this)
    this.navPayment = this.navPayment.bind(this)
    this.togglePGCharges = this.togglePGCharges.bind(this)
  }

  getFillList(actionID, exhibitionID, moduleID, keyValue, value) {
    this.setState({ isLoading: true })
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data.error != 1) {
          // country list
          if (actionID === paymentMasterListActionId) {
            console.log("country data", data.data)
            this.setState({
              paymentMasterList: data.data
            })
            data.data.length > 0 && data.data.map(item => {
              item.PaymentModuleID == 2 && this.setState({ isPaymentEnable: item.IsPaymentEnable })
            })
          }
          if (actionID === surchargeListActionId) {
            console.log("country data", data.data)
            this.setState({
              pgViewChargesFillList: data.data, isLoading: false,
            })
            // data.data.length > 0 && data.data.map(item => {
            //     item.PaymentModuleID == 2 && this.setState({ isPaymentEnable: item.IsPaymentEnable })
            // })
          }
        }
        else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((e) => {
        console.log(e);
      });

  }

  onSubmit(e) {
    var exbid = sessionStorage.getItem("sessionExhibitionID");
    var regid = sessionStorage.getItem("sessionExhRegistrationID");

    this.setState({ isLoading: true });
    this.props
      .lastSubmitAdd_action(exbid, regid)
      .then((data) => {
        this.setState({ isLoading: false });
        if (data.error != 1) {
          this.props.navigate("/thankYou");

          // toastSuccess("Your space booking application has been submitted successfully.");
        } else {
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    sessionStorage.setItem("renderPage", "summary", this.props.location);
    console.log('props==>', this.props.location)
    console.log('url from props==>', this.props.location.state.geturl)
    this.setState({
      geturl:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.geturl != " "
          ? this.props.location.state.geturl
          : "",
      toPay:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.toPay != " "
          ? this.props.location.state.toPay
          : "",
      toPaydummy:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.toPay != " "
          ? this.props.location.state.toPay
          : "",
      minPay:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.minPay != " "
          ? this.props.location.state.minPay
          : "",
      isCustompayment:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.isCustompayment != " "
          ? this.props.location.state.isCustompayment
          : "",
    });
    this.getFillList(paymentMasterListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '')
    this.getFillList(surchargeListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '')

    setTimeout(() => {
      this.setState({ isLoading: false });
      console.log('geturl after assigned in state==>', this.state.geturl)
    }, 10000);
    this.loadscript();
  }

  togglePGCharges(mode) {
    this.setState({ pgViewChargesModal: !this.state.pgViewChargesModal, isSurchargeForceOpen: mode != 1 ? false : this.state.isSurchargeForceOpen });
  }

  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  onPreviousClick() {
    sessionStorage.setItem("renderPage", "description");
    this.props.navigate("/description", { state: { is_update: true } });
  }

  onPayAndSubmit() {
    const { openPaymentPop, countryId, toPaydummy, EmailAuthorizedPerson, MobileAuthorizedPerson, ExhibitorCompanyName, DesignationAuthorizedPerson, AuthorizedPersonName } = this.state
    this.setState({ openPaymentPop: !openPaymentPop })
  }

  onPaymentTypeSelect(type) {
    const { openPaymentPop, toPaydummy } = this.state

    this.setState({ paymentType: type })
    if (type == 1) {
      this.setState({ toPay: toPaydummy })
    }
    else if (type == 2) {
      this.setState({ customPayment: '' })
    }
  }

  navPayment(e) {
    e.preventDefault()
    const { userId, selectedPIList, minPay, proformaInv, remark, paymentType, toPay, currency, } = this.state
    var ERROR = null
    if (toPay < minPay) {
      ERROR = `Total Payment amount should be greater than ${minPay}`
    }
    console.log(ERROR)
    if (ERROR == null) {
      this.setState({ isLoading: true })
      var moreInfo = null
      var exbid = sessionStorage.getItem("sessionExhibitionID");
      var regid = sessionStorage.getItem("sessionExhRegistrationID")
      console.log("++++++++++++++++++++++++++++++++++", sessionStorage.getItem("sessionContryName"))
      this.props.sendPaymentForm_action(exbid, regid, toPay, sessionStorage.getItem("countryId") == 91 ? 'INR' : 'USD', [], 'estimates', moreInfo, remark)
        .then((data) => {
          console.log(data)
          if (data.error != 1) {
            if (data != null) {
              console.log("payment response : ", data)

              // this.setState({ encPayload: data.data }, () => {
              //   this.submitfrm.current.submit()
              // })
              this.setState({ paymentLink: data.data }, () => {
                // this.submitfrm.current.submit()
                // window.open(data.data, '_blank')
                window.location.replace(data.data)

              })
            }
          }
          else {
            this.setState({ isLoading: false })
            toastError('There is some problem. Please try again later!')
          }
        })
        .catch((err) => {
          console.log(err)
        })

    }
    else {
      toastError(ERROR)
    }

  }

  render() {
    const { isLoading, geturl, openPaymentPop, pgViewChargesModal, paymentType, customPayment, toPay, encPayload, } = this.state;

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {/* <!-- PAGE --> */}
        {console.log('getURL in render==>', geturl)}
        <Header />
        {/* <!-- CONTAINER --> */}
        <div className="page-height" style={{ height: "auto" }}>
          <div className="main-container container-fluid">
            {/* <StepHeader /> */}

            {/* <!-- ROW-1 --> {geturl}*/}
            <div className="row ">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xl-12">
                <div className="row ">
                  <form className="needs-validation " novalidate="">
                    <div className="form-row mt-4">
                      {geturl != '' && <iframe
                        id="myIframe"
                        src={geturl}
                        width="400px"
                        height="400px"
                        title="Bing"
                      />}
                      {/* <div className="main-container container-fluid p-3 pt-0 pb-0">
                                                                <div className="mt-1 mb-4">
                                                                    <button className="btn apply-btn mt-2" type="submit">
                                                                        <a className="text-center " onClick={e => this.onSubmit(e)}>Submit</a>
                                                                    </button>
                                                                </div>
                                                            </div> */}

                      <div
                        class="mt-2 submit-center for-mob-bot-spc"
                        role="group"
                        aria-label="Basic example"
                        style={openPaymentPop == false ? { marginBottom: "100px !important", zIndex: '99999', position: 'relative' } : { marginBottom: "100px !important", }}
                      >
                        <button
                          className="btn btn-preview"
                          style={{
                            marginRight: "35px",
                            scale: "1.1"
                          }}
                          type="submit"
                          onClick={(e) => this.onPreviousClick(e)}
                        >
                          Previous
                        </button>
                        <button
                          type="button"
                          class="btn btn-submit"
                          style={{
                            marginRight: "35px",
                            scale: "1.1"
                          }}
                          onClick={(e) => this.onSubmit(e)}
                        >
                          {
                            sessionStorage.getItem("countryId") == 91 && JSON.parse(sessionStorage.getItem('paidByExh')) != false &&
                              this.state.isPaymentEnable ? 'Submit and Pay later' : 'Submit'}
                        </button>
                        {this.state.isPaymentEnable && JSON.parse(sessionStorage.getItem('paidByExh')) != false &&
                          sessionStorage.getItem("countryId") == 91 && <button
                            type="button"
                            class="btn btn-submit"
                            style={{ scale: "1.1" }}
                            onClick={(e) => this.onPayAndSubmit(e)}
                          >
                            Pay Now and Submit
                          </button>}
                      </div>

                      <Footer />
                      <div style={{ height: "80px" }}></div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={openPaymentPop} onRequestClose={() => this.setState({ openPaymentPop: false })}>
          <div className="modal-dialog" style={{ marginTop: '20%' }}>
            <div className="modal-content confirm-logout">
              <div class="modal-header text-right p-3">
                <h5 class="modal-title modal_title_text text-Primary">Payment</h5>
                <button
                  type="button"
                  className="btn-close mr-3"
                  data-bs-dismiss="modal"
                  style={{ fontSize: 12 }}
                  aria-label="Close"
                  onClick={(e) => this.setState({ openPaymentPop: false })}
                />
              </div>
              <div className="row m-3" >
                <div style={{ textAlign: 'left', fontWeight: '500', fontSize: '18px' }} className="col-md-6">
                  <input type="radio" style={{ width: '18px', height: '18px' }}
                    value={paymentType}
                    checked={paymentType == 1}
                    onClick={(e) => this.onPaymentTypeSelect(1)}
                  />
                  Full Payment
                </div>
                <div style={{ textAlign: 'left', fontWeight: '500', fontSize: '18px' }} className="col-md-6">
                  <input type="radio" style={{ width: '18px', height: '18px' }}
                    value={paymentType}
                    disabled={this.state.isCustompayment != 1}
                    checked={paymentType == 2}
                    onClick={(e) => this.onPaymentTypeSelect(2)}
                  />
                  Custom Payment
                  {paymentType == 2 && <input type="number" className="form-control"
                    value={customPayment}
                    // checked={generatePriorityNoType == 1}
                    onChange={(e) => this.setState({ customPayment: e.target.value, toPay: e.target.value == '' ? 0 : e.target.value })}
                  />}
                </div>
                <div className="" >
                  <div style={{ textAlign: 'left' }} className="col-md-12 mt-2">
                    <label>Remark</label>
                    <textarea value={this.state.remark} className="form-control" onChange={(e) => this.setState({ remark: e.target.value })}>

                    </textarea>
                  </div>
                </div>
                {/* <p className='mt-2 text-danger'><strong>Please note that bank charges alongwith GST will be applicable as per selected mode of payment in the next step (<a className='text-primary' onClick={() => this.togglePGCharges()} style={{ cursor: 'pointer' }}>View charges</a>) </strong></p> */}
              </div>
              <div class="modal-footer p-1" style={{ justifyContent: 'normal' }}>
                <div style={{ textAlign: 'left', fontWeight: '500', fontSize: '22px', padding: '0', float: 'left', left: '0' }} className="col-8 ms-2">
                  Total: {toPay}
                </div>
                {/* <div className="row" > */}
                <div className=" mt-1 col-3">
                  {/* {this.state.isSurchargeForceOpen ? <div style={{ float: 'right' }} className="mt-1 mb-1 mr-3 "> */}
                  {true ? <div style={{ float: 'right' }} className="mt-1 mb-1 mr-3 ">
                    {/* <form
                                            onSubmit={(e) => this.state.isSurchargeForceOpen ? this.togglePGCharges() : this.navPayment(e)}
                                            ref={this.submitfrm}
                                            id="nonseamless" method="post" name="redirect"
                                            action={this.state.paymentLink}
                                        > */}

                    {/* <input type="hidden" id="encRequest" name="encRequest"
                                                value={encPayload}
                                            /> */}
                    {/* <input type="hidden" name="access_code" id="access_code"
                                                value={paymentAccessCode}
                                            /> */}
                    <button className="btn btn-submit btn-full rounded-1"
                      onClick={(e) => this.togglePGCharges(1)}

                      disabled={toPay <= 0 || toPay == '' || toPay == null || paymentType == ''} style={{ border: 'none', borderRadius: '2px', scale: '1.2' }}>
                      {/* <span style={{ color: 'black', padding: "4px 20px", fontWeight: 500, }}> */}
                      pay
                      {/* </spa/n> */}
                      {/* {!isPaid && isCarParking == 1 ? 'Make Payment' : 'Update'} */}

                    </button>
                    {/* </form> */}
                  </div> :
                    <div style={{ float: 'right' }} className="mt-1 mb-1 mr-3 ">
                      <form
                        onSubmit={(e) => this.navPayment(e)}
                        ref={this.submitfrm}
                        id="nonseamless" method="post" name="redirect"
                        action={this.state.paymentLink}

                      >

                        {/* <input type="hidden" id="encRequest" name="encRequest"
                        value={encPayload}
                      />
                      <input type="hidden" name="access_code" id="access_code"
                        value={paymentAccessCode}
                      /> */}
                        <button className="btn btn-submit btn-full rounded-1" disabled={toPay <= 0 || toPay == '' || toPay == null || paymentType == ''} style={{ border: 'none', borderRadius: '2px', scale: '1.2' }}>
                          {/* <span style={{ color: 'black', padding: "4px 20px", fontWeight: 500, }}> */}
                          pay
                          {/* </span> */}
                          {/* {!isPaid && isCarParking == 1 ? 'Make Payment' : 'Update'} */}

                        </button>
                      </form>
                    </div>}
                </div>
                {/* </div> */}
              </div>
              {/* <div class="modal-footer p-1">
                <div style={{ textAlign: 'left', fontWeight: '500', fontSize: '22px', padding: '0', float: 'left', left: '0' }} className="col-9">
                  Total: {toPay}
                </div>
                <div className=" mt-1">
                  <div className="row" >
                    <div style={{ float: 'right' }} className="mt-1 mb-1 mr-3 col-6">
                      <form
                        onSubmit={(e) => this.navPayment(e)}
                        ref={this.submitfrm}
                        id="nonseamless" method="post" name="redirect"
                        action={paymentPortalLink}
                      >

                        <input type="hidden" id="encRequest" name="encRequest"
                          value={encPayload}
                        />
                        <input type="hidden" name="access_code" id="access_code"
                          value={paymentAccessCode}
                        />
                        <button className="btn btn-success rounded-1" disabled={toPay <= 0 || toPay == '' || toPay == null || paymentType == ''} style={{ border: 'none', borderRadius: '2px', }}>       <span style={{ color: 'black', padding: "4px 20px", fontWeight: 500, }}>
                          pay
                        </span>
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div> */}

            </div>
          </div>
        </Modal >
        <Modal
          isOpen={pgViewChargesModal}
          onRequestClose={() => this.setState({ pgViewChargesModal: false })}
          style={{
            content: {
              top: "300px",
              // maxHeight: "calc(100vh - 220px)",
            }
          }}
        >
          <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '120px' }}>
            <div className="modal-content responsive-width w-auto">
              <div className="modal-header p-3">
                <h4 className="mb-0 pt-2 text-success text-center fw-bold w-100">
                  Bank Charges
                </h4>
              </div>
              <div className="row m-3" >
                <p className='mt-2 text-danger'><strong>Please note that bank charges alongwith GST as per below table will be applicable as per selected mode of payment in the next step </strong></p>
                <table className="table table-bordered table-striped mg-b-0">
                  <thead>
                    <tr>
                      <th>Payment Mode</th>
                      <th>Bank Charges</th>
                    </tr>
                  </thead>
                  <tbody id="myTable">
                    {this.state.pgViewChargesFillList.length > 0 ? (
                      this.state.pgViewChargesFillList.map((data, i) => (
                        <tr key={i}>
                          <td className={data.isParent ? 'fw-bold' : ""}>{data.Description}</td>
                          <td>{data.Value}</td>
                        </tr>
                      ))
                    ) : (
                      <>
                        <tr>
                          <td colSpan={6}>No Records Found...</td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="modal-footer p-2 d-flex justify-content-end">
                {/* {this.state.isSurchargeForceOpen && <div className=" mt-1 col-3">\ */}
                {true && <div className=" mt-1 col-3">
                  <div style={{ float: 'right' }} className="mt-1 mb-1 mr-3 ">
                    <form
                      onSubmit={(e) => this.navPayment(e)}
                      ref={this.submitfrm}
                      id="nonseamless" method="post" name="redirect"
                      action={this.state.paymentLink}
                    >

                      {/* <input type="hidden" id="encRequest" name="encRequest"
                                                        value={encPayload}
                                                    /> */}
                      {/* <input type="hidden" name="access_code" id="access_code"
                                                        value={paymentAccessCode}
                                                    /> */}
                      <button className="btn btn-submit btn-full rounded-1" disabled={toPay <= 0 || toPay == '' || toPay == null || paymentType == ''} style={{ border: 'none', borderRadius: '2px', scale: '1.2' }}>
                        {/* <span style={{ color: 'black', padding: "4px 20px", fontWeight: 500, }}> */}
                        pay
                        {/* </span> */}
                        {/* {!isPaid && isCarParking == 1 ? 'Make Payment' : 'Update'} */}

                      </button>
                    </form>
                  </div>
                </div>}
                <button
                  className="btn btn-primary rounded-1"
                  onClick={() => this.togglePGCharges()}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </Modal>
        {/* <Footer/> */}
        {/* <!-- CONTAINER END --> */}
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    lastSubmitAdd_action, sendPaymentForm_action
  })(LastSubmit)
);
